<template>
    <div class="add-event-btn">
        <a href="#" class="btn btn-lg btn-default" @click="addEvent">
            <i class="glyphicon glyphicon-plus"></i>
            <b>&nbsp;{{translate('Page1.text19')}}</b>
        </a>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "addEventBtn",
        methods: {
            async addEvent() {
                try {
                    if(this.isEditorMode){
                        const {entityId} = await this.sendCommand({cmd: 'addEventScenario'});
                        this.openEventEditModal(entityId);
                    } else {

                        const {entityId} = await this.sendCommand({cmd: 'addEvent'});
                        this.openEventEditModal(entityId);
                    }
                    this.$eventHub.$emit('openMessageController', 'success' , this.translate('Popups.text17'));
                } catch(e) {
                    this.$eventHub.$emit('openMessageController', 'error' , this.translate('Popups.text18'));
                }
            },
            openEventEditModal (eventId) {
                this.$emit('openEventEditModal', eventId);
            },
            ...mapActions(['sendCommand'])
        },
        computed: {
            isEditorMode(){
                return this.$store.state.editMode;
            }
        }
    }
</script>

<style scoped>
    .add-event-btn {
        position: absolute;
        left: 10px;
        top: 10px;
    }
</style>